import { Link } from 'react-router-dom';

const faqs = [
  {
    q: '木瓜玩的服务覆盖哪些市场与平台？',
    a: '木瓜玩覆盖全球30+国家和地区，支持Meta Ads、Google Ads、TikTok、Unity Ads、Apple Search Ads等主流广告平台，并提供本地化运营服务。',
  },
  {
    q: '如何评估广告投放的ROI效果？',
    a: '木瓜玩提供全链路数据归因平台，支持第三方MMP数据接入，实时追踪从曝光到付费的完整转化路径，帮助您精准衡量每个渠道的投放效果。',
  },
  {
    q: '与木瓜玩合作需要多长启动周期？',
    a: '标准合作启动周期为1-2周，包括账户对接、SDK部署、策略制定和素材准备。紧急项目可压缩至3个工作日内完成上线。',
  },
  {
    q: '小型游戏开发团队可以使用木瓜玩的服务吗？',
    a: '当然可以。我们为不同规模的团队提供灵活的合作方案，从单渠道测试投放到全渠道规模化买量，都有匹配的服务套餐。',
  },
];

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14">
          <div>
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
              常见问题
            </span>
            <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-950 mb-8">
              您关心的问题都在这里
            </h2>
            <div className="space-y-4">
              {faqs.map((faq, idx) => (
                <details key={idx} className="group border border-background-200/70 rounded-lg overflow-hidden">
                  <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                    <span className="text-sm font-medium text-foreground-900 pr-4">{faq.q}</span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-200 text-base shrink-0"></i>
                  </summary>
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>

          <div className="bg-primary-500 rounded-lg p-8 md:p-10 flex flex-col justify-center relative overflow-hidden">
            <div className="absolute top-0 right-0 w-40 h-40 md:w-56 md:h-56 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
            <div className="absolute bottom-0 left-0 w-32 h-32 md:w-44 md:h-44 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/2"></div>
            <div className="relative z-10">
              <h3 className="font-heading font-bold text-xl md:text-2xl text-white mb-3">
                准备好开启全球增长了吗？
              </h3>
              <p className="text-sm md:text-base text-white/80 leading-relaxed mb-6">
                联系我们获取免费的增长诊断和定制化的出海方案，让您的游戏在海外市场脱颖而出。
              </p>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white text-primary-600 text-sm font-medium rounded-md hover:bg-white/90 transition-all duration-200 cursor-pointer whitespace-nowrap group"
              >
                立即咨询
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}